module.exports = {
    pca: require('area-data/pca'),
    pcaa: require('area-data/pcaa')
};